








































































































































































































import { Vue, Component, Prop }    from 'vue-property-decorator'
import { mapGetters }               from 'vuex'
import { FontAwesomeIcon }          from '@fortawesome/vue-fontawesome'

import { Ability }                  from '@/types/Ability'
import ExaGenericTable from '@exatech-group/generic-table/src/GenericTable.vue'
import { formatNumber, formatDate } from '@/utils/helpers'
import ErrorDisplay from '@/components/ErrorDisplay.vue'
import { TypeAjustement } from '@/types/EpreuveCorrectionResultat'



/**
 * Composant contenant l'ensemble des epreuveCorrectionResultats
*/
@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA']),
        ...mapGetters('epreuveCorrectionResultat', ['epreuveCorrectionResultatSelect', 'ajustementIsValidable', 'tableAjustementParams', 'epreuveCorrectionCorrecteurs', 'dicoNotesByUserId', 'notes', 'error', 'loading'])
    },
    components: {
        ExaGenericTable,
        'font-awesome-icon': FontAwesomeIcon,
        ErrorDisplay
    }
})

export default class EcartMoyenneCorrecteur extends Vue
{
    @Prop() epreuvecorrectionId: any
    @Prop() visible?: boolean
    @Prop() indexAjustement?: number

    formatNumber = formatNumber
    formatDate = formatDate

    sessionActive: any = null
    tableLoading = false
    params: any = null

    Ability = Ability

    footers: Array<any>  = []
    footers_supp: Array<any>  = []

    repereEcart = 0.5
    showEditEcartMyenneCorrecteur = false
    actionLimited = false
    ajustementValue = 0


    // Ensemble des colonnes du tableau de epreuveCorrectionResultats

    genericfields = [
        { key: 'etatEdit', label: '', sortable: false, class: '', type: 'action' },
        { key: 'user.name', label: 'Correcteur', sortable: true, class: 'text-start', type: 'text' },
        { key: 'moyenne_notes_brutes', label: 'Moyenne notes brutes', sortable: true, class: 'text-center', type: 'text' },
        { key: 'ecart', label: 'Écart', sortable: false, class: '', type: 'text' },
        { key: 'ecart_type_notes_brutes', label: 'Écart type note brutes', sortable: true, class: 'text-center', type: 'text' },
        { key: 'nb_note_min_brutes', label: 'Nombre de 0 notes brutes', sortable: true, class: 'text-center', type: 'text' },
        { key: 'nb_note_max_brutes', label: 'Nombre de 20 notes brutes', sortable: true, class: 'text-center', type: 'text' },
        { key: 'ajustement', label: 'Ajustement correcteur', sortable: false, class: 'text-center', type: 'text' },
        { key: 'moyenne_notes_finales', label: 'Moyenne notes ajustées', sortable: true, class: 'text-center', type: 'text' },
        { key: 'ecartb', label: 'Écart', sortable: false, class: 'text-center', type: 'text' },
        { key: 'nb_note_min_finales', label: 'Nombre de 0 notes ajustées', sortable: true, class: 'text-center', type: 'text' },
        { key: 'nb_note_max_finales', label: 'Nombre de 20 notes ajustées', sortable: true, class: 'text-center', type: 'text' }
    ]

    sortBy          = '';
    sortDesc        = false;
    sortDirection   = 'asc';
    filter          = '';
    filterOn        = [];
    stickyHeader    = true;

    filtres:    any         = []
    dataForTab: Array<any>  = []

    lib_epreuve = ''
    epreuveCorrectionCorrecteurTemp: any = null

    showModalMessageValidation = false

    ecart_moyenne_correcteurInfos: any = null

    validationEnCours = false
    enregistrementEnCours = false

    ajustementIsisValidable (indexAjustement: number, tableAjustementParams: Array<any>) {
        if (indexAjustement) {
            if (tableAjustementParams[indexAjustement - 1] &&
                tableAjustementParams[indexAjustement - 1].data.validated_at == null) {
                return false
            } else if (tableAjustementParams[indexAjustement + 1] &&
              tableAjustementParams[indexAjustement + 1].data.validated_at !== null) {
                return false
            }
        }
        return true
        // if((tableAjustementParams[indexAjustement + 1] && tableAjustementParams[indexAjustement + 1].data.validated_at === null) && (tableAjustementParams[indexAjustement - 1] && tableAjustementParams[indexAjustement - 1].data.validated_at !== null)
    }

    mounted() {
        if (JSON.stringify(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect) === '{}') {
            this.$store.dispatch('epreuveCorrectionResultat/getEpreuveCorrectionResultat', { epreuveCorrectionResultat_id: this.epreuvecorrectionId }).then(() => {
                this.suite()
            })
        } else {
            this.suite()
        }
    }

    suite () {
        this.tableLoading = true
        this.filtres = []
        this.loadCorrecteursEpreuves()
        const epcr = this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect
        const phaseLibelle = epcr.epreuve_correction && epcr.epreuve_correction.phase && epcr.epreuve_correction.phase.name ? epcr.epreuve_correction.phase.name : '-'
        let filiere = ''
        if (epcr.epreuve_correction && epcr.epreuve_correction.concours) {
            for (const concourkey in epcr.epreuve_correction.concours) {
                const concourTemp = epcr.epreuve_correction.concours[concourkey]
                if (concourTemp) {
                    if (filiere.length > 0 && concourTemp) {
                        filiere += ', '
                    }
                    filiere += concourTemp ? concourTemp.name : ''
                }
            }
        }
        this.lib_epreuve = phaseLibelle + ' - ' + filiere + ' - ' + (epcr.epreuve_correction && epcr.epreuve_correction.name ? epcr.epreuve_correction.name : '')
    }

    ecartChangeHandler () {
        this.setDataForGenericTab(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionCorrecteurs)
    }

    /**
     * Formatage des datas pour l'affichage dans le tableau générique
     */
    setDataForGenericTab(poData: any, isLoadMore = false)
    {
        if (!isLoadMore)
        {
            this.dataForTab = []
        }
        const dataBrut = {
            mediane: this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.mediane_notes_brutes,
            moyenne: this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.moyenne_notes_brutes,
            nb_note_max: this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.nb_note_max_brutes,
            nb_note_min: this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.nb_note_min_brutes,
            premier_quartile: this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.premier_quartile_notes_brutes,
            troisieme_quartile: this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.troisieme_quartile_notes_brutes,
            ecart_type_notes_brutes: this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.ecart_type_notes_brutes
        }
        // TODO brute => AVANT AJUSTEMENT

        const beforeInfos = this.indexAjustement && this.indexAjustement > 0 ?  this.$store.getters['epreuveCorrectionResultat/tableAjustementParams'](this.indexAjustement).data : dataBrut
        // console.log(beforeInfos)
        let libelleAjustementBefore = ''
        if (this.indexAjustement && this.indexAjustement > 0) {
            libelleAjustementBefore = this.$store.getters['epreuveCorrectionResultat/tableAjustementParams'](this.indexAjustement - 1).ajustement
        }

        let count = 0
        let total_moyenne_notes_brutes = 0
        let total_ecartb = 0
        let total_ecart_type_notes_brutes = 0
        let total_nb_note_min_brutes = 0
        let total_nb_note_max_brutes = 0
        let total_moyenne_notes_finales = 0
        let total_ecartf = 0
        let total_nb_note_min_finales = 0
        let total_nb_note_max_finales = 0

        this.ecart_moyenne_correcteurInfos = this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect && this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.ajustements_params && this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.ajustements_params.ecart_moyenne_correcteur && this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.ajustements_params.normalisation.infos ? this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.ajustements_params.ecart_moyenne_correcteur.infos : null
        if (poData)
        {
            for (const result of poData)
            {
                count++
                const ajustement_correcteur = result.ajustements_params
                let ajust_before_correcteur = null
                if (this.indexAjustement && this.indexAjustement > 0) {
                    ajust_before_correcteur = result.ajustements_params[libelleAjustementBefore].data
                } else {
                    ajust_before_correcteur = {
                        ecart_type: result.ecart_type_notes_brutes,
                        mediane: result.mediane_notes_brutes,
                        moyenne: result.moyenne_notes_brutes,
                        nb_note_max: result.nb_note_max_brutes,
                        nb_note_min: result.nb_note_min_brutes,
                        premier_quartile: result.premier_quartile_notes_brutes,
                        troisieme_quartile: result.troisieme_quartile_notes_brutes
                    }
                }
                // const nameEpreuveCorrection = '( ' + result.id + ' ) ' + result.epreuve_correction.name
                const identite = result.user ? ((result.user.name ? result.user.name : '-') + ' ' + (result.user.first_name ? result.user.first_name : '-')) : '-'

                const moyenne_notes_brutes = ajust_before_correcteur.moyenne ? formatNumber(ajust_before_correcteur.moyenne) : '0'
                total_moyenne_notes_brutes += ajust_before_correcteur.moyenne ? ajust_before_correcteur.moyenne : 0

                const ecartb = ajust_before_correcteur.moyenne - beforeInfos.moyenne
                total_ecartb += ajust_before_correcteur.moyenne - beforeInfos.moyenne
                const ecartBrute = formatNumber(ecartb)

                const classEcartBrute = 'text-center' + (ecartb > 0 && ecartb > this.repereEcart ? ' text_gras text-success' : (ecartb < 0 && ecartb < (this.repereEcart * -1) ? ' text_gras text-danger' : ''))
                const ecart_type_notes_brutes = ajust_before_correcteur.ecart_type ? formatNumber(ajust_before_correcteur.ecart_type) : '0'
                total_ecart_type_notes_brutes += ajust_before_correcteur.ecart_type ? ajust_before_correcteur.ecart_type : 0

                const nb_note_min_brutes = ajust_before_correcteur.nb_note_min ? ajust_before_correcteur.nb_note_min : '0'
                total_nb_note_min_brutes += ajust_before_correcteur.nb_note_min ? ajust_before_correcteur.nb_note_min : 0

                const nb_note_max_brutes = ajust_before_correcteur.nb_note_max ? ajust_before_correcteur.nb_note_max : '0'
                total_nb_note_max_brutes += ajust_before_correcteur.nb_note_max ? ajust_before_correcteur.nb_note_max : 0

                const ajustement = ajustement_correcteur.ecart_moyenne_correcteur && ajustement_correcteur.ecart_moyenne_correcteur.params && ajustement_correcteur.ecart_moyenne_correcteur.params.ecart_moyenne && ajustement_correcteur.ecart_moyenne_correcteur.params.ecart_moyenne !== '0' && ajustement_correcteur.ecart_moyenne_correcteur.params.ecart_moyenne !== 0 ? ajustement_correcteur.ecart_moyenne_correcteur.params.ecart_moyenne : '-'
                const classAjustement = ajustement !== '-' ? (ajustement > 0 ? 'text-center text_gras text-success' : 'text-center text_gras text-danger') : ''

                const moyenne_notes_finales = ajustement_correcteur.ecart_moyenne_correcteur.infos.moyenne ? formatNumber(ajustement_correcteur.ecart_moyenne_correcteur.infos.moyenne) : '0'
                total_moyenne_notes_finales += ajustement_correcteur.ecart_moyenne_correcteur.infos.moyenne ? ajustement_correcteur.ecart_moyenne_correcteur.infos.moyenne : 0

                const ecartf  = this.ecart_moyenne_correcteurInfos ? ajustement_correcteur.ecart_moyenne_correcteur.infos.moyenne - this.ecart_moyenne_correcteurInfos.moyenne : 0
                const ecartFinale = formatNumber(ecartf)
                total_ecartf += ecartf

                const classEcartFinale = (ecartf > 0 && ecartf > this.repereEcart ? ' text_gras text-success' : (ecartf < 0 && ecartf < (this.repereEcart * -1) ? ' text_gras text-danger' : ''))

                const nb_note_min_finales = ajustement_correcteur.ecart_moyenne_correcteur.infos.nb_note_min ? ajustement_correcteur.ecart_moyenne_correcteur.infos.nb_note_min : '0'
                total_nb_note_min_finales += ajustement_correcteur.ecart_moyenne_correcteur.infos.nb_note_min ? ajustement_correcteur.ecart_moyenne_correcteur.infos.nb_note_min : 0

                const nb_note_max_finales = ajustement_correcteur.ecart_moyenne_correcteur.infos.nb_note_max ? ajustement_correcteur.ecart_moyenne_correcteur.infos.nb_note_max : '0'
                total_nb_note_max_finales += ajustement_correcteur.ecart_moyenne_correcteur.infos.nb_note_max ? ajustement_correcteur.ecart_moyenne_correcteur.infos.nb_note_max : 0

                const ajustementIsValidate = this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.ajustements_params.ecart_moyenne_correcteur.validated_at !== null
                // console.log(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.ajustements_params.ecart_moyenne_correcteur.validated_at

                /*
                { key: 'nb_note_max_finales', label: 'Nombre de 20 notes ajustées', sortable: true, class: '', type: 'text' }
                */

                const line = [
                    { label: 'Editer', item: result, type: 'action', typeAction: 'edit', class: 'commons_first_action_button', icon:'pen', disabled: ajustementIsValidate },
                    { label: '', item: identite, type: 'text', typeAction: null, class: 'text-start' },
                    { label: '', item: moyenne_notes_brutes, type: 'text', typeAction: null, class: 'text-center' },
                    { label: '', item: ecartBrute, type: 'text', typeAction: null, class: classEcartBrute },
                    { label: '', item: ecart_type_notes_brutes, type: 'text', typeAction: null, class: 'text-center' },
                    { label: '', item: nb_note_min_brutes, type: 'text', typeAction: null, class: 'text-center' },
                    { label: '', item: nb_note_max_brutes, type: 'text', typeAction: null, class: 'text-center' },
                    { label: '', item: ajustement, type: 'text', typeAction: null, class: 'text-center background_td' + classAjustement },
                    { label: '', item: moyenne_notes_finales, type: 'text', typeAction: null, class: 'text-center' },
                    { label: '', item: ecartFinale, type: 'text', typeAction: null, class: classEcartFinale },
                    { label: '', item: nb_note_min_finales, type: 'text', typeAction: null, class: 'text-center' },
                    { label: '', item: nb_note_max_finales, type: 'text', typeAction: null, class: 'text-center' }
                ]
                this.dataForTab.push(line)
            }
        }
        this.footers = [
            {
                key: '0',
                label: '',
                colspan: 1,
                class: 'text-start'
            },
            {
                key: '1',
                label: 'Global sur l\'épreuve',
                colspan: 1,
                class: 'text-start'
            },
            {
                key: '2',
                label: beforeInfos.moyenne ? formatNumber(beforeInfos.moyenne) : '-',
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '3',
                label: '',
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '4',
                // label: beforeInfos.moyenne.ecart_type ? formatNumber(beforeInfos.moyenne.ecart_type) : '-',
                label: dataBrut.ecart_type_notes_brutes ? formatNumber(dataBrut.ecart_type_notes_brutes) : '99',
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '5',
                label: beforeInfos.nb_note_min ? beforeInfos.nb_note_min : '-',
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '6',
                label: beforeInfos.nb_note_max ? beforeInfos.nb_note_max : '-',
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '7',
                label: '',
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '8',
                label: this.ecart_moyenne_correcteurInfos && this.ecart_moyenne_correcteurInfos.moyenne ? formatNumber(this.ecart_moyenne_correcteurInfos.moyenne) : '-',
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '9',
                label: '',
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '10',
                label: this.ecart_moyenne_correcteurInfos && this.ecart_moyenne_correcteurInfos.nb_note_min ? this.ecart_moyenne_correcteurInfos.nb_note_min : '-',
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '11',
                label: this.ecart_moyenne_correcteurInfos && this.ecart_moyenne_correcteurInfos.nb_note_max ? this.ecart_moyenne_correcteurInfos.nb_note_max : '-',
                colspan: 1,
                class: 'text-center'
            }
        ]


        /*







        */
        this.footers_supp = [
            {
                key: '0',
                label: '',
                colspan: 1,
                class: 'text-start'
            },
            {
                key: '1',
                label: 'Moyenne des informations',
                colspan: 1,
                class: 'text-start'
            },
            {
                key: '2',
                label: formatNumber(total_moyenne_notes_brutes / count),
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '3',
                label: formatNumber(total_ecartb / count),
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '4',
                label:formatNumber(total_ecart_type_notes_brutes / count),
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '5',
                label: formatNumber(total_nb_note_min_brutes / count),
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '6',
                label: formatNumber(total_nb_note_max_brutes / count),
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '7',
                label: '-',
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '8',
                label: formatNumber(total_moyenne_notes_finales / count),
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '9',
                label: formatNumber(total_ecartf / count),
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '10',
                label: formatNumber(total_nb_note_min_finales / count),
                colspan: 1,
                class: 'text-center'
            },
            {
                key: '11',
                label: formatNumber(total_nb_note_max_finales / count),
                colspan: 1,
                class: 'text-center'
            }
        ]
    }

    /**
     * Formatage des datas pour l'affichage dans le tableau générique
     */
    setFiltersForGenericTab()
    {
        this.filtres =
        [
            /*
            { libelle: 'Correcteur', defautOptionlibelle: 'Rechercher un', model: 'candidat.name', value: '', index: 'candidat.name', datas: null, loading: false, options: { type: 'form', fieldsKey: 'candidat.name' } },
            { libelle: 'Numéro \'anonymat', defautOptionlibelle: 'Rechercher un', model: 'candidat.num_anonymat', value: '', index: 'candidat.num_anonymat', datas: null, loading: false, options: { type: 'form', fieldsKey: 'candidat.num_anonymat' } },
            { libelle: 'Correcteur', defautOptionlibelle: 'Rechercher un', model: 'user.name', value: '', index: 'user.name', datas: null, loading: false, options: { type: 'form', fieldsKey: 'user.name' } },
            { libelle: 'Note Brute', defautOptionlibelle: 'Rechercher une', model: 'note_brute', value: '', index: 'note_brute', datas: null, loading: false, options: { type: 'form', fieldsKey: 'note_brute' } },
            { libelle: 'Note Finale', defautOptionlibelle: 'Rechercher une', model: 'note_finale', value: '', index: 'note_finale', datas: null, loading: false, options: { type: 'form', fieldsKey: 'note_finale' } },
            { libelle: 'Note Réclamation', defautOptionlibelle: 'Rechercher une', model: 'note_reclamation', value: '', index: 'note_reclamation', datas: null, loading: false, options: { type: 'form', fieldsKey: 'note_reclamation' } }
            */
        ]
    }

    /**
     * Récupération des events du tableau
     * params[0] => l'action
     * params[1] => l'id de l'item
     */
    handleTableEvent (paParams: any): void
    {
        if (paParams && paParams[0] && paParams[1])
        {
            switch (paParams[0])
            {
                case 'edit':
                    this.$store.state.epreuveCorrectionResultat.error = null
                    this.epreuveCorrectionCorrecteurTemp = this.$store.getters['epreuveCorrectionResultat/getepreuveCorrectionCorrecteurById'](paParams[1].id)
                    this.ajustementValue = this.epreuveCorrectionCorrecteurTemp.ajustements_params && this.epreuveCorrectionCorrecteurTemp.ajustements_params.ecart_moyenne_correcteur && this.epreuveCorrectionCorrecteurTemp.ajustements_params.ecart_moyenne_correcteur.params && this.epreuveCorrectionCorrecteurTemp.ajustements_params.ecart_moyenne_correcteur.params.ecart_moyenne ? this.epreuveCorrectionCorrecteurTemp.ajustements_params.ecart_moyenne_correcteur.params.ecart_moyenne : 0
                    this.showEditEcartMyenneCorrecteur = true
                    break
                case 'sortHandler':
                    this.filtreSortHandler(paParams[1])
                    break

                case 'filterHandler':
                    this.filtreSortHandler(paParams[1])
                    break

                case 'onLoadPage':
                    // this.loadHandler(paParams[1])
                    break

                default:
                    break
            }
        }
    }

    validerAjustement () {
        this.$store.state.epreuveCorrectionResultat.error = null
        this.showModalMessageValidation = true
    }

    cancelValidate () {
        this.showModalMessageValidation = false
    }

    validateSuite () {
        this.validationEnCours = true
        const payload = {
            ajustement_name: TypeAjustement.TYPE_ECART_MOYENNE_CORRECTEUR,
            epreuvecorrectionresultat_id: this.epreuvecorrectionId,
            params: [],
            validate: this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect.ajustements_params.ecart_moyenne_correcteur.validated_at ? 0 : 1

        }
        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }

        this.$bvToast.toast('Enregistrement en cours ...', infosToaster)
        this.$store.dispatch('epreuveCorrectionResultat/updateEpreuveCorrectionResultats', payload).then(() => {
            this.$bvToast.hide(idInfo)
            const idSucces = 't_succes_' + Math.random()
            const succesToaster = {
                id: idSucces,
                toaster: 'b-toaster-top-right',
                variant: 'success',
                noCloseButton: true,
                fade: true,
                autoHideDelay: 5000
            }
            this.$bvToast.toast('Enregistrement terminé.', succesToaster)
            this.showModalMessageValidation = false
            this.setDataForGenericTab(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionCorrecteurs)
            this.validationEnCours = false
        }).catch((error) => {
            this.$bvToast.hide(idInfo)
            console.log('ko:' + error)
            this.validationEnCours = false
        })
    }

    valideEdit () {
        this.enregistrementEnCours = true
        const payload = {
            epreuvecorrectioncorrecteur_id: this.epreuveCorrectionCorrecteurTemp.id,
            ajustement_name: TypeAjustement.TYPE_ECART_MOYENNE_CORRECTEUR,
            params: {
                ecart_moyenne: this.ajustementValue
            }
        }
        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }

        this.$bvToast.toast('Enregistrement en cours ...', infosToaster)
        this.$store.dispatch('epreuveCorrectionResultat/updateEpreuveCorrectionCorrecteur', payload).then(() => {
            this.$store.dispatch('epreuveCorrectionResultat/getEpreuveCorrectionResultat', { epreuveCorrectionResultat_id: this.epreuvecorrectionId }).then(() => {
                this.$bvToast.hide(idInfo)
                const idSucces = 't_succes_' + Math.random()
                const succesToaster = {
                    id: idSucces,
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                    noCloseButton: true,
                    fade: true,
                    autoHideDelay: 5000
                }
                this.$bvToast.toast('Enregistrement terminé.', succesToaster)
                this.showEditEcartMyenneCorrecteur = false
                this.epreuveCorrectionCorrecteurTemp = null
                this.setDataForGenericTab(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionCorrecteurs)
                this.enregistrementEnCours = false
            }).catch((error) => {
                this.$bvToast.hide(idInfo)
                console.log('ko:' + error)
                this.enregistrementEnCours = false
            })
        }).catch((error) => {
            this.$bvToast.hide(idInfo)
            console.log('ko:' + error)
            this.enregistrementEnCours = false
        })
    }

    cancelEdit () {
        this.showEditEcartMyenneCorrecteur = false
        this.epreuveCorrectionCorrecteurTemp = null
    }

    /**
     * Récupération sur le serveur des 100 premiers epreuveCorrectionResultats s'ils ne sont pas déja
     * présents dans le state
     */
    loadCorrecteursEpreuves ()
    {
        this.params = { page: 1, sort: 'user.name', direction: 'asc', 'filter-epreuve_correction_id': this.epreuvecorrectionId }
        this.$store.dispatch('epreuveCorrectionResultat/getEpreuveCorrectionCorrecteurs', this.params).then((response) => {
            this.tableLoading = false
            this.setDataForGenericTab(response.data.data)
        }).catch((error) => {
            console.log('ko:' + error)
        })
    }

    /**
     * Appel d'une nouvelle page de epreuveCorrectionResultats lors du scroll
     */
    filtreSortHandler (params: any)
    {
        params['filter-epreuve_correction_id'] = this.epreuvecorrectionId
        if (JSON.stringify(this.params) !== JSON.stringify(params)) {
            this.$store.state.epreuveCorrectionResultat.epreuveCorrectionCorrecteurs = []
            this.setDataForGenericTab(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionCorrecteurs)
            this.params = params
            this.tableLoading = true
            this.$store.dispatch('epreuveCorrectionResultat/getEpreuveCorrectionCorrecteurs', this.params).then(() => {
                this.setDataForGenericTab(this.$store.state.epreuveCorrectionResultat.epreuveCorrectionCorrecteurs)
                this.tableLoading = false
            }).catch((error) => {
                console.log('ko:' + error)
            })
        }
    }
}
